var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows / Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2234 4.55806C11.4675 4.31398 11.8632 4.31398 12.1073 4.55806L17.1073 9.55806C17.3514 9.80214 17.3514 10.1979 17.1073 10.4419L12.1073 15.4419C11.8632 15.686 11.4675 15.686 11.2234 15.4419C10.9793 15.1979 10.9793 14.8021 11.2234 14.5581L15.1565 10.625H3.33203C2.98685 10.625 2.70703 10.3452 2.70703 10C2.70703 9.65482 2.98685 9.375 3.33203 9.375H15.1565L11.2234 5.44194C10.9793 5.19786 10.9793 4.80214 11.2234 4.55806Z",
    fill: "#2D2D2D"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowRight.fb08fc38906ff1611f26ffdc0041f6bc.svg";